<template>
    <div class="version-info">
        ©2024-present 新潮传媒集团
        <span v-if="version">&nbsp; v{{ version }}</span>
        <span v-if="env">&nbsp;&nbsp; env:{{ env }}</span>
    </div>
</template>

<script>
export default {
    name: 'Version',
    data() {
        return {
            env: window.XCConfig.VUE_APP_ENV,
            version: VERSION,
        };
    }
};
</script>

<style type="scss" scoped>
.version-info {
  font-size: 12px;
  color: rgb(139, 154, 175);
  text-align: center;
}
</style>
